import React from "react";
import { useNavigate } from 'react-router-dom';

const AgentActivityExpanded = () => {
  const navigate = useNavigate();

  const data = [];

  return (
    <div
       className="container-fluid px-4 pt-5 pb-3 d-flex flex-column" style={{ minHeight: '100vh' }}
    >
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center  mb-5">
        <h5
          className="fw-semibold mb-0"
          style={{ color: '#2E2868', fontSize: '1.4375rem' }}
        >
          Agent Activity
        </h5>
        <div className="d-flex align-items-center gap-2">
          <select className="form-select form-select-sm w-auto">
            <option>Yesterday</option>
            <option>Last 7 Days</option>
            <option>Last 30 Days</option>
          </select>
          <button
            className="btn btn-sm"
            style={{
              backgroundColor: '#2E2868',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              padding: '6px 12px',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
            }}
            onClick={() => navigate('/')}
          >
            ✕ Close
          </button>
        </div>
      </div>

      {/* Table Wrapper with Scroll */}
      <div className="border rounded-3 overflow-auto" style={{ maxHeight: 'calc(100vh - 150px)' }}>

        <table className="table table-sm table-borderless align-middle mb-0">
          
          <thead className="text-muted small" style={{ height: '48px' }}>
            <tr className="border-bottom">
              <th style={{ position: 'sticky', top: 0, backgroundColor: '#d3d3d3', zIndex: 2 }}>
                Channel <span style={{ color: '#6f42c1' }}>▼</span>
              </th>
              <th style={{ position: 'sticky', top: 0, backgroundColor: '#d3d3d3', zIndex: 2 }}>
                Total Outreach  <span style={{ color: '#6f42c1' }}>▼</span>
              </th>
              <th style={{ position: 'sticky', top: 0, backgroundColor: '#d3d3d3', zIndex: 2 }}>
                Responses <span style={{ color: '#6f42c1' }}>▼</span>
              </th>
              <th style={{ position: 'sticky', top: 0, backgroundColor: '#d3d3d3', zIndex: 2 }}>
                Conversion Rate
                <span style={{ color: '#6f42c1' }}>▼</span>
              </th>

            </tr>
          </thead>


          <tbody>
            {data.map((row, idx) => (
              <tr key={idx} className="border-bottom" style={{ height: '48px' }}>
                <td>{row.channel}</td>
                <td>{row.outreach.toLocaleString()}</td>
                <td>{row.responses.toLocaleString()}</td>
                <td>{row.rate}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AgentActivityExpanded;
